module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00057-fs8.f89a2b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00057-fs8.png
// module id = 210
// module chunks = 0